// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.application.SatelliteWebLandlordApplicationHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebLandlordApplicationHandler_applicationsAccepted,
  SatelliteWebLandlordApplicationHandler_inviteToApply,
} from '@zg-rentals/ts-satellite-client';

import type {
  SatelliteWebLandlordApplicationApplicationsAcceptedRequestDto,
  SatelliteWebLandlordApplicationInviteToApplyRequestDto,
} from '@zg-rentals/ts-satellite-client';

export interface SatelliteWebLandlordApplicationHandler_applicationsAccepted_Args {
  postData: SatelliteWebLandlordApplicationApplicationsAcceptedRequestDto;
}

export type SatelliteWebLandlordApplicationHandler_applicationsAccepted_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordApplicationHandler_applicationsAccepted_Args
>;

/**
 * Enable applications accepted for a listing
 */
export const useSatelliteWebLandlordApplicationHandler_applicationsAccepted = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordApplicationHandler_applicationsAccepted_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordApplicationHandler_applicationsAccepted_Args) =>
      SatelliteWebLandlordApplicationHandler_applicationsAccepted(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordApplicationHandler_inviteToApply_Args {
  postData: SatelliteWebLandlordApplicationInviteToApplyRequestDto;
}

export type SatelliteWebLandlordApplicationHandler_inviteToApply_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordApplicationHandler_inviteToApply_Args
>;

/**
 * Invite a renter to apply for a property
 */
export const useSatelliteWebLandlordApplicationHandler_inviteToApply = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordApplicationHandler_inviteToApply_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordApplicationHandler_inviteToApply_Args) =>
      SatelliteWebLandlordApplicationHandler_inviteToApply(args.postData, httpClient),
  });
};
